import React from 'react';
import styled from 'styled-components/native';
import TextGeneric from '../textGeneric';
import {AlphabetItemProps} from '../../interfaces/components/alphabetItem';

const Container = styled.TouchableOpacity<{isSelected?: boolean}>`
  width: ${({theme}) => theme.text.s1 * 1.2}px;
  height: ${({theme}) => theme.text.s1 * 1.2}px;
  overflow: hidden;
  background-color: ${({theme, isSelected}) =>
    isSelected ? theme.primary : theme.screenBackground};
  border-radius: ${({theme}) => theme.text.s1 / 3}px;
  border-width: 2px;
  border-color: ${({theme, isSelected}) =>
    isSelected ? theme.primary : theme.primary + '22'};
  align-items: center;
  justify-content: center;
`;
const Value = styled(TextGeneric)<{isSelected?: boolean}>`
  font-size: ${({theme}) => theme.text.s7}px;
  color: ${({theme, isSelected}) =>
    isSelected ? theme.text.light : theme.text.dark};
`;

/**
 * AlphabetItem component .
 *
 * @param {AlphabetItemProps} props - Component props
 * @returns {React.ReactElement} The AlphabetItem component
 */
const AlphabetItem: React.FC<AlphabetItemProps> = ({
  style,
  value,
  onPress,
  isSelected,
}: AlphabetItemProps): React.ReactElement => {
  if (!value) return <></>;
  return (
    <Container
      disabled={!onPress}
      onPress={onPress}
      style={style}
      isSelected={isSelected}>
      <Value semiBold isSelected={isSelected}>
        {value || ''}
      </Value>
    </Container>
  );
};

export default AlphabetItem;
